<script setup lang="ts">
withDefaults(defineProps<{
  showText?: boolean
}>(), {
  showText: true
})
</script>

<template>
  <span class="loading-indicator" :class="{ 'is-icon-only': !showText }" role="status" :aria-label="showText ? undefined : '加载中'">
    <span class="loading-indicator-ring" aria-hidden="true" />
    <span v-if="showText">加载中...</span>
  </span>
</template>

<style scoped>
.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 32px;
  color: var(--text-soft);
  font-size: 13px;
}

.loading-indicator-ring {
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border: 2px solid color-mix(in srgb, var(--brand) 22%, transparent);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: loading-indicator-spin 0.75s linear infinite;
}

.loading-indicator.is-icon-only {
  display: inline-flex;
  min-height: 0;
  color: inherit;
  font-size: inherit;
}

.loading-indicator.is-icon-only .loading-indicator-ring {
  width: 1em;
  height: 1em;
}

@keyframes loading-indicator-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-indicator-ring {
    animation: none;
  }
}
</style>
